<template>
		<div class="radio form-inline">
				<div v-for="(radio, index) in radios">
						<label style="padding-right: 10px;">
								<input
										type="radio"
										:name="name"
										:id="name + '_' + index"
										@change="onChange"
										:value="radio.value"
										:disabled="radio.disabled === true"
										v-model="selectedItem"
										v-validate="(index == 0) ? 'required': ''"
								/>
								{{radio.label}}
						</label>
				</div>
				<span v-show="errors.length > 0" v-for="error in errors" class="help is-danger">{{ error }}</span>
		</div>
</template>

<style>
</style>

<script>
module.exports = {
	props: {
		value: {type: [String, Number], default: ''},
		name: {type: String},
		radios: {type: Array, default: function () { return []; }},
		label: {type: String, default: ''},
		disabled: {type: Boolean, default: false},
		errors: {type: Array, default: () => ([])}
	},
	data: function () {
		return {
			selectedItem: this.value
		};
	},
	methods: {
		onChange: function (event) {
			this.$emit('input', this.selectedItem);
		}
	}
};
</script>



// WEBPACK FOOTER //
// f-radio.vue?dec7469a